import { createFileRoute } from '@tanstack/react-router';
import { TenantContext } from '@interxfi/api-client';
import { PageLayout } from '@interxfi/app-components/components/layout/page-layout/page-layout';
import { RequiresAccess } from '@interxfi/design-system/access-context';
import { HorizontalStack } from '@interxfi/design-system/components/alignment/horizontal-stack';
import { Button } from '@interxfi/design-system/components/button';
import type { CustomTableHeaderProps } from '@interxfi/design-system/components/table';
import PlusIcon from '@interxfi/design-system/icons/react/icon-plus';
import { CreateProgramDrawer } from '../../../../../../features/userauth/program/create-program-drawer';
import { useCanCreateProgram } from '../../../../../../features/userauth/program/program-permission-helpers';
import { ProgramsTable } from '../../../../../../features/userauth/program/programs-table';
import type { RouteGuardOptions } from '../../../../../../util/routing/guard';
import { getPageHead } from '../../../../../../util/routing/meta';

export const Route = createFileRoute('/_app/_platform/_context-required/program/_program/')({
  staticData: {
    guard: { access: { allowedTenantTypes: [TenantContext.Platform, TenantContext.Organization] } },
  } as const satisfies RouteGuardOptions,
  shouldReload: true,
  head: () => getPageHead('Programs'),
  component: ProgramList,
});

function TableHeader({ filter }: CustomTableHeaderProps) {
  // Only platform users should be able to create programs
  const canCreateProgram = useCanCreateProgram(undefined);

  return (
    <HorizontalStack align="end" blockAlign="center" gap={2} wrap="nowrap">
      <HorizontalStack blockAlign="center" gap={2} wrap="nowrap">
        {canCreateProgram ? (
          <RequiresAccess write>
            <CreateProgramDrawer trigger={<Button affixIcon={<PlusIcon aria-hidden />} aria-label="New Program" size="small" />} />
          </RequiresAccess>
        ) : null}
        {filter}
      </HorizontalStack>
    </HorizontalStack>
  );
}

function ProgramList() {
  return (
    <PageLayout>
      <PageLayout.Section noBorder>
        <ProgramsTable HeaderActions={TableHeader} />
      </PageLayout.Section>
    </PageLayout>
  );
}
